import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ProjectTaskHeader = ({
  userInfo,
  breadCrumbText,
  title,
  reloadList,
  updateBulkTaskHandler,
  projectid,
  isProjectModerator,
  projectMemberStatus,
  projectModStatus,
  setselectedTaskModerator,
  updateScheduleStateHandler = () => {},
  downloadAsExcel = () => {},
  jsonFilterQuery = [], // Added jsonFilterQuery prop
  selectedTaskIds = [], // Assuming a prop for selected task IDs for action menu logic
}) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white mt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb
            breadCrumbText={breadCrumbText}
            bottom={true}
            displayName={`${title}`}
          />
        </div>
        {isProjectModerator ||
        (projectMemberStatus === "1" && projectModStatus === "1") ? (
          <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
            <Link
              onClick={reloadList}
              to="#"
              className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
              title={t("Reload")}
            >
              <span className="material-symbols-outlined icon-md me-1">
                refresh
              </span>
              <span className="fw-semibold small">{t("Reload")}</span>
            </Link>

            {/* <!-- ========== Start view switch Section ========== --> */}
            <div className="dropdown flex-fill flex-grow-sm-0">
              <button
                className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="fw-semibold small">{t("List View")}</span>
                <span className="material-symbols-outlined icon-lg ms-1">
                  expand_more
                </span>
              </button>
              <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
                <li>
                  <Link
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    to={`/admin/projectmanagement/tasksection/${projectid}`}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      list
                    </span>
                    <span className="d-block">{t("Section View")}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    to={`/admin/projectmanagement/tasklist/${projectid}`}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      list
                    </span>
                    <span className="d-block">{t("List View")}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    to={`/admin/projectmanagement/kanban/${projectid}`}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      view_kanban
                    </span>
                    <span className="d-block">{t("Kanban View")}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    to={`/admin/projectmanagement/gantt/${projectid}`}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      insert_chart_outlined
                    </span>
                    <span className="d-block">{t("Gantt View")}</span>
                  </Link>
                </li>
              </ul>
            </div>
            {/* <!-- ========== End view switch Section ========== --> */}

            <div className="dropdown flex-fill flex-grow-sm-0">
              <button
                className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="fw-semibold small">{t("Action")}</span>
                <span className="material-symbols-outlined icon-lg ms-1">
                  expand_more
                </span>
              </button>
              <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
                {/* --- add label start --- */}
                <li>
                  <Link
                    to="#"
                    className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                      selectedTaskIds.length === 0 ? "disabled text-muted" : ""
                    }`}
                    data-bs-toggle={
                      selectedTaskIds.length === 0 ? undefined : "modal"
                    }
                    data-bs-target={
                      selectedTaskIds.length === 0
                        ? undefined
                        : "#addLabelModal"
                    }
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      label
                    </span>
                    <span className="d-block">{t("Manage Label")}</span>
                  </Link>
                </li>
                {/* --- add label start --- */}{" "}
                <li>
                  <Link
                    className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                      selectedTaskIds.length === 0 ? "disabled text-muted" : ""
                    }`}
                    to="#"
                    data-bs-toggle={
                      selectedTaskIds.length === 0 ? undefined : "modal"
                    }
                    data-bs-target={
                      selectedTaskIds.length === 0 ? undefined : "#addFollowers"
                    }
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      person
                    </span>
                    <span className="d-block">{t("Add Followers")}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                      selectedTaskIds.length === 0 ? "disabled text-muted" : ""
                    }`}
                    onClick={() => {
                      if (selectedTaskIds.length > 0) {
                        updateBulkTaskHandler();
                      }
                    }}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      progress_activity
                    </span>
                    <span className="d-block">{t("Update Task")}</span>
                  </Link>
                </li>
                {/* <!-- ========== Start bulk task Section ========== --> */}
                <li>
                  <Link
                    to="#"
                    className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                      selectedTaskIds.length === 0 ? "disabled text-muted" : ""
                    }`}
                    data-bs-toggle={
                      selectedTaskIds.length === 0 ? undefined : "modal"
                    }
                    data-bs-target={
                      selectedTaskIds.length === 0
                        ? undefined
                        : "#addAssingTask"
                    }
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      task
                    </span>
                    <span className="d-block">{t("Assign Tasks")}</span>
                  </Link>
                </li>
                {/* <!-- ========== End bulk task Section ========== --> */}
                {/* <!-- ========== Start massive delete task Section ========== --> */}
                <li>
                  <Link
                    to="#"
                    className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                      selectedTaskIds.length === 0
                        ? "disabled text-muted"
                        : "text-danger"
                    }`}
                    data-bs-toggle={
                      selectedTaskIds.length === 0 ? undefined : "modal"
                    }
                    data-bs-target={
                      selectedTaskIds.length === 0
                        ? undefined
                        : "#projectTaskDeleteModal"
                    }
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      delete
                    </span>
                    <span className="d-block">{t("Delete Tasks")}</span>
                  </Link>
                </li>
                {/* <!-- ========== End massive delete task Section ========== --> */}
                <hr className="dropdown-divider" /> {/* Added hr here */}
                <li>
                  <Link
                    className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                      selectedTaskIds.length === 0 ? "disabled text-muted" : ""
                    }`}
                    to="#"
                    data-bs-toggle={
                      selectedTaskIds.length === 0 ? undefined : "modal"
                    }
                    data-bs-target={
                      selectedTaskIds.length === 0
                        ? undefined
                        : "#createAlertModal"
                    }
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      alarm
                    </span>
                    <span className="d-block">{t("Create alert")}</span>
                  </Link>
                </li>{" "}
                {/* <!-- ========== Start schedule update Section ========== --> */}
                <li>
                  <Link
                    to="#"
                    className={`dropdown-item d-flex align-items-center gap-2 py-2 ${
                      selectedTaskIds.length === 0 ? "disabled text-muted" : ""
                    }`}
                    type="button"
                    // data-bs-toggle="offcanvas"
                    // data-bs-target="#UpdateTaskSchedule"
                    // aria-controls="UpdateTaskSchedule"
                    onClick={() => {
                      if (selectedTaskIds.length > 0) {
                        updateScheduleStateHandler();
                      }
                    }}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      schedule
                    </span>
                    <span className="d-block">{t("Update Schedule")}</span>
                  </Link>
                </li>
                {/* <!-- ========== End schedule update Section ========== --> */}
                <hr className="dropdown-divider" />
                <li>
                  <Link
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    to="#"
                    onClick={downloadAsExcel}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      download
                    </span>
                    <span className="d-block">{t("Download as Excel")}</span>
                  </Link>
                </li>
              </ul>
            </div>

            <Link
              to="#"
              className={`btn ${
                jsonFilterQuery.length > 0
                  ? "btn-outline-primary"
                  : "btn-light border"
              } d-flex align-items-center px-4 py-2 rounded-3 shadow-sm`}
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#taskAdvanceFilter"
              aria-controls="taskAdvanceFilter"
            >
              <span className="material-symbols-outlined icon-md me-1">
                tune
              </span>
              <span className="fw-semibold small">{t("Filter")}</span>
              <span
                className={
                  jsonFilterQuery.length > 0
                    ? "bg-primary text-white ms-1 rounded-circle fs-xs"
                    : "d-none"
                }
                style={{ minWidth: 22, minHeight: 22 }}
              >
                {jsonFilterQuery.length}
              </span>
            </Link>
            {/* {isProjectModerator && (
              <Link
                to="#"
                className="btn btn-primary d-flex align-items-center gap-1"
                data-bs-toggle="modal"
                data-bs-target="#addSectionModal"
              >
                <span className="d-block material-symbols-outlined icon-md">
                  add
                </span>
                <span className="d-block">Add Section</span>
              </Link>
            )} */}
            <Link
              to="#"
              className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#addTask_view"
              aria-controls="addTask_view"
              onClick={() => {
                setselectedTaskModerator(userInfo._id);
              }}
            >
              <span className="material-symbols-outlined icon-md">add</span>
              <span>{t("New Task")}</span>
            </Link>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ProjectTaskHeader;
